module.exports = __webpack_public_path__ + "7361164ff4611f1a75cc49cd90b3d3de.svg";